import { handleErrorWithSentry } from '@sentry/sveltekit';
import { init } from '@jill64/sentry-sveltekit-cloudflare/client';

init('https://4172e154ba619d15e7e06e15583a9ad8@o4507141296685056.ingest.de.sentry.io/4507141298716752', {
    sentryOptions: {
        // Errors-only: no performance tracing (quota incident 2026-07)
        tracesSampleRate: 0,

        // Errors-only: Session Replay fully disabled (quota incident 2026-07)
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0
    }
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
